import React, { useState } from "react";
import "../css/Common.css";
// RepaymentDetails.css also supplies the global bare-table styles that the
// Dashboard previews rely on — keep this import even though this page no
// longer uses those classes.
import "../css/RepaymentDetails.css";
import "../css/repayLoan.css";
import IndusIndQRImage from "../images/IndusInd_QR.webp";
import payULogo from "../images/payu.webp";
import paytmLogo from "../images/paytm.webp";
import { Link, useNavigate } from "react-router-dom";
import PaymentModal from "../components/Payment/PaymentModal";
import urls from "../Utils/urls";
import { Helmet } from "react-helmet";

/* ── icons ── */
const IcoShield = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 12 11 14 15 10" /></svg>;
const IcoBolt = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>;
const IcoReceipt = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1V2l-2 1-2-1-2 1-2-1-2 1-2-1z" /><line x1="8" y1="8" x2="16" y2="8" /><line x1="8" y1="13" x2="14" y2="13" /></svg>;
const IcoLock = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;
const IcoCheckBig = () => <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoCheckSm = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoCopy = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>;
const IcoInfo = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg>;
const IcoAlert = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>;
const IcoScan = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7V5a2 2 0 0 1 2-2h2" /><path d="M17 3h2a2 2 0 0 1 2 2v2" /><path d="M21 17v2a2 2 0 0 1-2 2h-2" /><path d="M7 21H5a2 2 0 0 1-2-2v-2" /><line x1="7" y1="12" x2="17" y2="12" /></svg>;
const IcoPhone = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;

/* ── static data ── */
const STEPS = [
  { n: 1, sub: "Step 1", label: "Verify PAN" },
  { n: 2, sub: "Step 2", label: "Confirm OTP" },
  { n: 3, sub: "Step 3", label: "Make Payment" },
];

const STEP_INDEX = { pannumber: 0, panotp: 1, amountfetched: 2, paymentSuccess: 3 };

const BANKS = [
  // {
  //   id: "indusind",
  //   name: "IndusInd Bank",
  //   initials: "IB",
  //   badge: "rl-badge-green",
  //   rows: [
  //     // { k: "Company Name", v: "Salary Uncle" },
  //     { k: "Account No", v: "258130930990", copy: true },
  //     { k: "IFSC", v: "INDB0001907", copy: true },
  //     { k: "UPI ID", v: "Pos.5314125@indus", copy: true },
  //   ],
  // },
  // {
  //   id: "hdfc",
  //   name: "HDFC Bank",
  //   initials: "HB",
  //   badge: "rl-badge-dark",
  //   rows: [
  //     // { k: "Company Name", v: "Salary Uncle" },
  //     { k: "Account No", v: "99999643336036", copy: true },
  //     { k: "IFSC", v: "HDFC0000287", copy: true },
  //   ],
  // },
  {
    id: "julania",
    name: "JULANIA FINANCE PVT LTD",
    initials: "JF",
    badge: "rl-badge-dark",
    rows: [
      // { k: "Company Name", v: "Salary Uncle" },
      { k: "Account No", v: "201037792232", copy: true },
      { k: "IFSC", v: "INDB0001907", copy: true },
    ],
  },
];

const inr = (n) => Number(n || 0).toLocaleString("en-IN");

// A single live account gets a full-width card with side-by-side detail tiles;
// re-enabling a second bank in BANKS restores the original two-up layout.
const isSoloBank = BANKS.length === 1;

const RepayLoan = (props) => {
  const [content, setContent] = useState("pannumber");
  const [getLoading, setLoading] = useState(false);
  const [getPancard, setPancard] = useState("");
  const [getOtp, setOtp] = useState("");
  const [repaymentData, setRepaymentData] = useState(null);
  const [orderId, setOrderId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [copiedKey, setCopiedKey] = useState("");
  const [paytmError, setPaytmError] = useState("");

  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const sendOtp = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${urls.API_BASEPATH}${urls.payment.SEND_OTP}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
          Accept: "application/json",
        },
        body: JSON.stringify({ pancard: getPancard }),
      });

      if (resp.status === 200) {
        const dataset = await resp.json();
        props.showmessage(dataset.Message, dataset.Status === 1 ? "success" : "error");
        if (dataset.Status === 1) {
          setContent("panotp");
        }
      } else {
        const dataset = await resp.json();
        props.showmessage(dataset.Message, "error");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      props.showmessage("Unable to send OTP. Please check your connection and try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    if (!isChecked) {
      props.showmessage("Please accept the terms and conditions to proceed.", "error");
      return; // Prevent OTP verification if checkbox is unchecked
    }

    setLoading(true);
    try {
      const resp = await fetch(`${urls.API_BASEPATH}${urls.payment.VERIFY_OTP}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Auth: "Y2M0Nzk0OGYwNmQyMjdmZTlhY2E1ZWQ1Nzk5YTZmMWE=",
          Accept: "application/json",
        },
        body: JSON.stringify({
          panNumber: getPancard,
          otp: getOtp,
        }),
      });

      if (resp.status === 200) {
        const dataset = await resp.json();
        props.showmessage(dataset.Message, dataset.Status === 1 ? "success" : "error");

        if (dataset.Status === 1) {
          const repaymentData = dataset.repayment_data;
          setRepaymentData(repaymentData);
          setOrderId(dataset.order_id);
          setContent("amountfetched");
        }
      } else {
        const dataset = await resp.json().catch(() => ({}));
        props.showmessage(dataset.Message || "OTP verification failed. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      props.showmessage("Unable to verify OTP. Please check your connection and try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  let processing = false;
  const payWithPayU = async () => {
    if (processing) return;
    processing = true;

    setLoading(true);
    try {
      const total_due_amount = paymentAmount || repaymentData.total_due_amount; // Use part payment amount if provided
      const MERCHANT_KEY = "oMcSQ9";
      const productinfo = "Loan repayment for Loan No";
      const fullname = repaymentData.full_name;
      const email = repaymentData.email;
      const phone = repaymentData.mobile;

      const response = await fetch(`${urls.API_BASEPATH}${urls.payment.PAYU_ORDERS}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Auth": "MjQ4ZmY5MGM0MmM2N2EyOTJlZWE0MTBiNGU2Y2Q2NzU="
        },
        body: JSON.stringify({
          amount: total_due_amount,
          productinfo: productinfo,
          firstname: fullname,
          email: email,
          mobile: phone,
          udf5: repaymentData.lead_id
        }),
      });

      const data = await response.json();

      if (data.Status === 1) {
        const hashData = data.data.parameters;

        const payuOptions = {
          key: MERCHANT_KEY,
          txnid: hashData.txnid,
          amount: total_due_amount,
          productinfo: productinfo,
          firstname: fullname,
          email: email,
          phone: phone,
          surl: `${urls.SITE_URL}/thanku`,
          furl: `${urls.SITE_URL}/fail`,
          hash: hashData.hash,
          udf5: repaymentData.lead_id
        };

        const scriptLoaded = await loadScript("https://jssdk.payu.in/bolt/bolt.min.js");

        if (scriptLoaded) {
          if (typeof window.bolt !== 'undefined') {
            console.log("Bolt Options", payuOptions);
            window.bolt.launch(payuOptions, {
              responseHandler: function (BOLT) {
                console.log(BOLT);
                if (BOLT.response.txnStatus === "SUCCESS") {
                  // Pass the transaction status to the Thank You page via React Router's state
                  navigate("/thanku", { state: { txnStatus: BOLT.response.txnStatus, txnId: BOLT.response.txnid } });
                }
                if (BOLT.response.txnStatus === "FAILED" || BOLT.response.txnStatus === "CANCEL") {
                  navigate("/thanku", { state: { txnStatus: BOLT.response.txnStatus, txnId: BOLT.response.txnid } });
                }
              },
              catchException: function (BOLT) {
                console.log(BOLT);
                console.log('Payment failed. Please try again.');
              }
            });
          } else {
            console.error("PayU SDK not initialized correctly after loading.");
            props.showmessage("Payment could not be started. Please try again.", "error");
          }
        } else {
          console.error("Failed to load PayU script.");
          props.showmessage("Unable to load the payment gateway. Please check your connection and try again.", "error");
        }
      } else {
        console.error("Failed to get valid response from PayU API.");
        props.showmessage(data.Message || data.message || "Payment initialization failed. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error during PayU payment:", error);
      props.showmessage(error?.message || "Something went wrong while starting the payment. Please try again.", "error");
    } finally {
      setLoading(false);
      processing = false;
    }
  };

  const payWithPaytm = async () => {
    if (processing) return;
    processing = true;

    setLoading(true);

    try {
      const total_due_amount = paymentAmount || repaymentData.total_due_amount;
      const response = await fetch(`${urls.API_BASEPATH}${urls.payment.INITIALIZE_PAYTM}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: total_due_amount,
          lead_id: repaymentData.lead_id,
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let data = await response.json();
      // The API may return the payload either as a JSON object or as a
      // double-encoded JSON string. Only parse again when it's still a string.
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      // Guard against error-shaped responses that lack head/body — surface the
      // server's own message instead of a cryptic "cannot read property" crash.
      if (!data || !data.head || !data.body || !data.body.resultInfo) {
        throw new Error(data?.Message || data?.message || "Transaction Failed. Please try again.");
      }
      const bodyData = {}
      bodyData.signature = data.head.signature ? data.head.signature : ""
      bodyData.txnId = data.body.txnToken ? data.body.txnToken : ""
      bodyData.amount = data.amount ? data.amount : ""
      bodyData.orderId = data.orderId ? data.orderId : ""
      bodyData.status = data.body.resultInfo.resultCode == "0000" && data.body.resultInfo.resultMsg == "Success" && data.body.resultInfo.resultStatus == "S" ? data.body.resultInfo.resultMsg : ""
      if (bodyData.status == "" || bodyData.txnId == "" || bodyData.signature == "" || bodyData.amount == "" || bodyData.orderId == "") {
        throw new Error("Transaction Failed Request is invalid Please try again")
      }

      if (bodyData.status === "Success") {
        const form = document.createElement("form");
        form.method = "POST";
        form.action =
          // "https://securestage.paytmpayments.com/theia/api/v1/showPaymentPage" +
          // `?mid=NPEGdG28759680978804&orderId=${bodyData.orderId}`;
          "https://secure.paytmpayments.com/theia/api/v1/showPaymentPage" +
          `?mid=JULANI94894178833911&orderId=${bodyData.orderId}`;

        const midInput = document.createElement("input");
        midInput.type = "hidden";
        midInput.name = "mid";
        // midInput.value = "NPEGdG28759680978804";
        midInput.value = "JULANI94894178833911";

        const orderInput = document.createElement("input");
        orderInput.type = "hidden";
        orderInput.name = "orderId";
        orderInput.value = bodyData.orderId;

        const tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "txnToken";
        tokenInput.value = bodyData.txnId;

        form.appendChild(midInput);
        form.appendChild(orderInput);
        form.appendChild(tokenInput);

        document.body.appendChild(form);
        form.submit(); // REDIRECTS TO PAYTM
      }
      else {
        console.warn("Payment initialization failed:", data.message);
        // Show the server's own message inside the modal instead of closing it.
        setPaytmError(data?.body?.resultInfo?.resultMsg || data.message || "Payment initialization failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during PAYTM payment:", error);
      // Surface the backend/thrown message inside the modal (errorMessage).
      setPaytmError(error?.message || "Something went wrong while starting the payment. Please try again.");
    } finally {
      setLoading(false);
      processing = false;
    }
  };

  const handlePAN = (e) => {
    const value = e.target.value.toUpperCase();
    if (/^[A-Z]{0,5}$/.test(value.slice(0, 5)) && /^[\d]{0,4}$/.test(value.slice(5, 9)) && /^[A-Z]{0,1}$/.test(value.slice(9))) {
      setPancard(value);
    }
  };

  const handleOTP = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 4) {
      setOtp(value);
    }
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePaymentClick = () => {
    setPaytmError("");
    setModalOpen(true);
    setLoading(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handlePayU = () => {
    setModalOpen(false);
    payWithPayU();
    setLoading(false);
  };

  const handlePaytm = () => {
    // Keep the modal open. On success payWithPaytm redirects the whole page;
    // on failure it sets paytmError, which the modal shows inline (no close).
    setPaytmError("");
    payWithPaytm();
    setLoading(false);
  };

  // Rupees with up to two paise digits; no leading zeros other than "0."
  const handlePaymentAmountChange = (e) => {
    const value = e.target.value;
    if (value === "" || (/^\d*\.?\d{0,2}$/.test(value) && !/^0\d/.test(value))) {
      setPaymentAmount(value);
    }
  };

  const changePan = () => {
    setOtp("");
    setIsChecked(false);
    setContent("pannumber");
  };

  const copyValue = async (key, value) => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = value;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopiedKey(key);
    setTimeout(() => setCopiedKey((k) => (k === key ? "" : k)), 1600);
  };

  const activeStep = STEP_INDEX[content] ?? 0;
  const isPanValid = getPancard.length === 10;
  const totalDue = repaymentData ? Number(repaymentData.total_due_amount) : 0;
  const effectiveAmount = paymentAmount === "" ? totalDue : Number(paymentAmount);
  const isAmountValid = effectiveAmount > 0;
  const isOverpaying = isAmountValid && effectiveAmount > totalDue;

  return (
    <>
      {isModalOpen && (
        <PaymentModal
          onClose={handleCloseModal}
          // onPayu={handlePayU}
          onPaytm={handlePaytm}
          isLoading={getLoading}
          errorMessage={paytmError}
        />
      )}

      <Helmet>
        <title>Repay Your Loan Online Easily | Salary Uncle</title>
        <meta name="description" content="Find bank details to repay your Salary Uncle loan securely. Use account info or scan QR code for fast, hassle-free repayment. Quick and safe transactions." />
        <meta property="og:title" content="Repay Your Loan Online Easily | Salary Uncle" />
        <meta property="og:description" content="Find bank details to repay your Salary Uncle loan securely. Use account info or scan QR code for fast, hassle-free repayment. Quick and safe transactions." />
        <link rel="canonical" href={`${urls.SITE_URL}/repay-loan`} />
      </Helmet>

      {/* ── HERO ── */}
      <section className="rl-hero">
        <div className="rl-hero-inner">
          {/* <span className="rl-tag">REPAY LOAN</span> */}
          <h1>Repay Loan</h1>
          {/* <p>
            Verify your PAN, check your outstanding amount and pay securely —
            <br />or transfer directly to any of our bank accounts.
          </p> */}

          <nav className="rl-crumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">→</span>
            <span aria-current="page">Repay Loan</span>
          </nav>

          {/* <div className="rl-trust">
            <span className="rl-trust-item"><IcoShield /> 100% Secure Payment</span>
            <span className="rl-trust-item"><IcoBolt /> Instant Confirmation</span>
            <span className="rl-trust-item"><IcoReceipt /> Part Payment Allowed</span>
          </div> */}
        </div>
      </section>

      {/* ── BODY ── */}
      <section className="rl-body">
        <div className="rl-body-inner">

          {/* LEFT — scan & pay */}
          <aside className="rl-aside">
            <div className="rl-card rl-qrcard d-none">
              <div className="rl-bank-head">
                <div className="rl-bank-badge rl-badge-green"><IcoScan /></div>
                <div>
                  <h3>Scan &amp; Pay</h3>
                  <small>IndusInd Bank · any UPI app</small>
                </div>
              </div>
              <div className="rl-qr">
                <img src={IndusIndQRImage} alt="IndusInd Bank payment QR code" />
                <div className="rl-qr-cap"><IcoScan /> Scan with any UPI app</div>
              </div>
            </div>

            {/* <div className="rl-note">
              <IcoAlert />
              <p>
                Paying by QR or direct transfer? Always add your <strong>Loan Number</strong> in the
                remarks so we can match the payment to your account.
              </p>
            </div> */}

            <div className="rl-help">
              <h3>Need Help Repaying?</h3>
              <p>Our support team is available Mon–Sat, 9 AM – 7 PM.</p>
              {/* <a href="tel:+918448980504" className="rl-help-btn"><IcoPhone /> +91 8448980504</a> */}
              <a href="tel:+917042561004" className="rl-help-btn"><IcoPhone /> +91 7042561004</a>
            </div>
          </aside>

          {/* RIGHT — bank details, then pay online */}
          <div className="rl-main">

            {/* Bank transfer details */}
            <div className="rl-banks">
              {BANKS.map((bank) => (
                <div className={`rl-card rl-bank ${isSoloBank ? "rl-bank--solo" : ""}`} key={bank.id}>
                  <div className="rl-bank-head">
                    <div className={`rl-bank-badge ${bank.badge}`}>{bank.initials}</div>
                    <div>
                      <h3>{bank.name}</h3>
                      <small>Direct bank transfer</small>
                    </div>
                  </div>

                  <div className="rl-bank-rows">
                    {bank.rows.map((row) => {
                      const key = `${bank.id}-${row.k}`;
                      return (
                        <div className="rl-detail" key={key}>
                          <span className="rl-detail-k">{row.k}</span>
                          <span className="rl-detail-v">
                            <span title={row.v}>{row.v}</span>
                            {row.copy && (
                              <button
                                type="button"
                                className={`rl-copy ${copiedKey === key ? "is-copied" : ""}`}
                                onClick={() => copyValue(key, row.v)}
                                aria-label={`Copy ${row.k}`}
                                title={copiedKey === key ? "Copied!" : `Copy ${row.k}`}
                              >
                                {copiedKey === key ? <IcoCheckSm /> : <IcoCopy />}
                              </button>
                            )}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>

            {/* Stepper */}
            <div className="rl-card rl-steps">
              {STEPS.map((step, i) => (
                <React.Fragment key={step.n}>
                  {i > 0 && (
                    <div className={`rl-step-line ${activeStep >= i ? "is-done" : ""}`} />
                  )}
                  <div className={`rl-step ${activeStep === i ? "is-active" : ""} ${activeStep > i ? "is-done" : ""}`}>
                    <div className="rl-step-dot">
                      {activeStep > i ? <IcoCheckSm /> : step.n}
                    </div>
                    <div className="rl-step-label">
                      <small>{step.sub}</small>
                      <strong>{step.label}</strong>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>

            {/* STEP 1: PAN INPUT */}
            {content === "pannumber" && (
              <div className="rl-card rl-panel">
                <div className="rl-panel-head">
                  <div className="rl-panel-icon"><IcoLock /></div>
                  <div>
                    <h2>Verify Your Identity</h2>
                    <p>Enter your PAN to fetch your loan details securely.</p>
                  </div>
                </div>

                <div className="rl-field">
                  <label htmlFor="rl-pan">PAN Number</label>
                  <input
                    id="rl-pan"
                    type="text"
                    className="rl-input rl-input-pan"
                    value={getPancard}
                    onChange={handlePAN}
                    maxLength={10}
                    placeholder="ABCDE1234F"
                    autoComplete="off"
                    spellCheck="false"
                    required
                  />
                  <span className="rl-hint">
                    <IcoInfo /> We send a one-time password to the mobile number registered with this PAN.
                  </span>
                </div>

                <button className="rl-btn rl-btn-primary" onClick={sendOtp} disabled={!isPanValid || getLoading}>
                  {getLoading ? <span className="rl-spinner" /> : "Get OTP"}
                </button>
              </div>
            )}

            {/* STEP 2: OTP INPUT */}
            {content === "panotp" && (
              <div className="rl-card rl-panel">
                <div className="rl-panel-head">
                  <div className="rl-panel-icon"><IcoShield /></div>
                  <div>
                    <h2>Enter the OTP</h2>
                    <p>We've sent a 4-digit code to your registered mobile number.</p>
                  </div>
                </div>

                <div className="rl-pan-badge">
                  <div className="rl-pan-badge-val">
                    <small>PAN Number</small>
                    <strong>{getPancard}</strong>
                  </div>
                  <button type="button" className="rl-link-btn" onClick={changePan} disabled={getLoading}>
                    Change
                  </button>
                </div>

                <div className="rl-field">
                  <label htmlFor="rl-otp">One-Time Password</label>
                  <input
                    id="rl-otp"
                    type="text"
                    className="rl-input rl-input-otp"
                    placeholder="••••"
                    value={getOtp}
                    onChange={handleOTP}
                    maxLength={4}
                    inputMode="numeric"
                    autoComplete="one-time-code"
                  />
                  <span className="rl-hint">
                    Didn't receive it?
                    <button type="button" className="rl-link-btn" onClick={sendOtp} disabled={getLoading}>
                      Resend OTP
                    </button>
                  </span>
                </div>

                <div className="rl-check">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    id="termsCheck"
                  />
                  <label htmlFor="termsCheck">
                    I accept the <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>,{" "}
                    <Link to="/privacy-policy">Privacy Policy</Link> and consent to payment processing.
                  </label>
                </div>

                <button
                  className="rl-btn rl-btn-primary"
                  onClick={verifyOtp}
                  disabled={!isChecked || getOtp.length !== 4 || getLoading}
                >
                  {getLoading ? <span className="rl-spinner" /> : "Get Amount"}
                </button>
              </div>
            )}

            {/* STEP 3: REPAYMENT DETAILS */}
            {content === "amountfetched" && repaymentData && (
              <div className="rl-card rl-panel">
                <div className="rl-panel-head">
                  <div className="rl-panel-icon"><IcoReceipt /></div>
                  <div>
                    <h2>Loan Repayment Details</h2>
                    <p>Review your outstanding balance before paying.</p>
                  </div>
                </div>

                <div className="rl-total">
                  <div className="rl-total-k">
                    <small>Total Due</small>
                    <span>Payable as on today</span>
                  </div>
                  <div className="rl-total-v">₹{inr(repaymentData.total_due_amount)}</div>
                </div>

                <div className="rl-summary">
                  <div className="rl-row">
                    <span className="rl-row-k">Loan Number</span>
                    <span className="rl-row-v">{repaymentData.loan_no}</span>
                  </div>
                  <div className="rl-row">
                    <span className="rl-row-k">Disbursal Date</span>
                    <span className="rl-row-v">{repaymentData.disbursal_date}</span>
                  </div>
                  <div className="rl-row">
                    <span className="rl-row-k">Repayment Date</span>
                    <span className="rl-row-v">{repaymentData.repayment_date}</span>
                  </div>
                  <div className="rl-row">
                    <span className="rl-row-k">Loan Amount</span>
                    <span className="rl-row-v">₹{inr(repaymentData.loan_recommended)}</span>
                  </div>
                  <div className="rl-row">
                    <span className="rl-row-k">Interest</span>
                    <span className="rl-row-v">₹{inr(repaymentData.real_interest)}</span>
                  </div>
                  <div className="rl-row">
                    <span className="rl-row-k">Repayment Amount</span>
                    <span className="rl-row-v">₹{inr(repaymentData.repayment_amount)}</span>
                  </div>
                </div>

                {!isModalOpen && (
                  <div className="amountToPay">
                    <div className="rl-field">
                      <label htmlFor="rl-amount">Amount To Pay</label>
                      <div className="rl-amount-wrap">
                        <span className="rl-rupee">₹</span>
                        <input
                          id="rl-amount"
                          type="text"
                          className="rl-input"
                          value={paymentAmount}
                          onChange={handlePaymentAmountChange}
                          placeholder={inr(repaymentData.total_due_amount)}
                          inputMode="decimal"
                          autoComplete="off"
                        />
                      </div>

                      <div className="rl-chip-row">
                        <button
                          type="button"
                          className="rl-chip"
                          onClick={() => setPaymentAmount(String(repaymentData.total_due_amount))}
                        >
                          Pay full ₹{inr(repaymentData.total_due_amount)}
                        </button>
                        {paymentAmount !== "" && (
                          <button type="button" className="rl-chip" onClick={() => setPaymentAmount("")}>
                            Clear
                          </button>
                        )}
                      </div>

                      {isOverpaying && (
                        <span className="rl-hint">
                          <IcoInfo /> This is more than your total due of ₹{inr(totalDue)}.
                        </span>
                      )}
                    </div>

                    <button
                      className="rl-btn rl-btn-primary"
                      onClick={handlePaymentClick}
                      disabled={!isAmountValid || getLoading}
                    >
                      {getLoading ? <span className="rl-spinner" /> : <>Proceed to Pay ₹{inr(effectiveAmount)}</>}
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* STEP 4: PAYMENT SUCCESS */}
            {content === "paymentSuccess" && (
              <div className="rl-card rl-success">
                <div className="rl-success-icon"><IcoCheckBig /></div>
                <h3>{paymentStatus || "Payment Successful"}</h3>
                <p>Thank you for your payment! A confirmation will reach you shortly.</p>
              </div>
            )}

            {/* Payment partners */}
            {/* <div className="rl-card rl-partners">
              <span className="rl-partners-title">Payments processed securely by</span>
              <div className="rl-partners-logos">
                <img src={paytmLogo} alt="Paytm" loading="lazy" />
                <img src={payULogo} alt="PayU" loading="lazy" />
              </div>
              <span className="rl-partners-note"><IcoLock /> Secured with 256-bit SSL encryption</span>
            </div> */}
          </div>

        </div>
      </section>
    </>
  );
};

export default RepayLoan;
